import React from "react";
import BannerWrapper from "../../../commonComponents/BannerWrapper";
import HeadingH1 from "../../../utls/HeadingH1";
const TravelArrangementBanner = ({ onLoad }) => {
  return (
    <BannerWrapper onLoad={onLoad}>
      {({ useHighRes, imageLoaded, handleImageLoad }) => (
        <div
          className="container-fluid ctm-banner position-relative p-0"
          style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
        >
          <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/6.%20Travel%20Arrangements.webp"
            alt="Travel Arrangements Banner"
            className="w-100"
            loading={useHighRes ? "eager" : "lazy"}
            onLoad={handleImageLoad}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
          {imageLoaded ? (
            <div className="ctm-text position-absolute text-white mt-2 mt-md-1">
              <p className="fs4 text-uppercase busy">TRAVEL WITH PRIDE</p>
              <HeadingH1 className="banner-headings w-75">
                Your Well-Being, Our Commitment
              </HeadingH1>
              <div className="d-flex common-second-content">
                <div className="ornge-border"></div>
                <div className="second-content">
                  Worried about the complexities of corporate travel? Let us
                  take care of every detail, from flights to accommodations,
                  ensuring your business trips are smooth and productive.
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )}
    </BannerWrapper>
  );
};

export default TravelArrangementBanner;
